import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const fetchAdminEmployeeList = createAsyncThunk(
  'adminUsers/fetchEmployeeList',
  async (
    { page = 1, rowsPerPage = 50, searchTerm = '', teamFilter = '', sortColumn = '', sortDirection = 'asc', accessFilter = '' },
    { signal, rejectWithValue }
  ) => {
    try {
      const res = await axios.get(`${API_URL}/api/Admin/users/EmployeeList`, {
        signal,
        headers: { 'Content-Type': 'application/json' },
        params: {
          page,
          rowsPerPage,
          searchTerm,
          teamFilter,
          sortColumn,
          sortDirection,
          accessFilter,
        },
      });

      const data = res.data || {};
      return {
        rows: Array.isArray(data.rows) ? data.rows : [],
        totalRows: Number.isFinite(Number(data.totalRows)) ? Number(data.totalRows) : 0,
      };
    } catch (e) {
      // If the thunk was aborted (navigation/unmount), let RTK mark it as aborted.
      if (e?.code === 'ERR_CANCELED' || e?.name === 'CanceledError') throw e;
      console.error('adminUsers/fetchEmployeeList failed', e);
      return rejectWithValue(e?.message || 'Failed to fetch users');
    }
  }
);

const initialState = {
  rows: [],
  totalRows: 0,
  loading: false,
  error: null,
};

const adminUsersSlice = createSlice({
  name: 'adminUsers',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdminEmployeeList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAdminEmployeeList.fulfilled, (state, action) => {
        state.loading = false;
        state.rows = action.payload?.rows || [];
        state.totalRows = action.payload?.totalRows || 0;
      })
      .addCase(fetchAdminEmployeeList.rejected, (state, action) => {
        state.loading = false;
        if (action?.meta?.aborted) return;
        state.error = action.payload || action.error?.message || 'Failed to fetch users';
      });
  },
});

export default adminUsersSlice.reducer;


